import axios, { AxiosInstance, AxiosPromise } from 'axios';
import {appURLS} from "appRoot/app.constants";
import { IBooking } from 'app/app.types';
import AdminService from "external-services/diary-admin-service/admin.service";
import NetworkRequestsService from 'external-services/network-requests-service';
const api: AxiosInstance = NetworkRequestsService.getGlobalAPI();

const NS = 'PreAuthService';

export class PreAuthService {

  public charge(booking: IBooking, amount: number): AxiosPromise<any> {

    const data = {
      venueId: AdminService.getVenue().id,
      bookingId: booking._id,
      customerId: booking.customerId || (booking as any).customer._id,
      chargingAmount: amount
    };

    return api.post(appURLS.API + '/restaurants/payments/preauth', data);
  }
}

const instance = new PreAuthService();
export default instance as PreAuthService;
